import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
} from '@angular/core';
import { IAgent, ICustomerDetails } from '@dxp/core/models';
import { TelXLAgentActivityHistoryPanelComponent } from './agent/agent-activity-history-panel.component';
import { TelXLCustomerActivityHistoryPanelComponent } from './customer/customer-activity-history-panel.component';

@Component({
    selector: 'telxl-shared-activity-history-panel',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        TelXLCustomerActivityHistoryPanelComponent,
        TelXLAgentActivityHistoryPanelComponent,
    ],
    templateUrl: './activity-history-panel.component.html',
    styleUrl: './activity-history-panel.component.scss',
})
export class TelXLActivityHistoryPanelComponent {
    agent = input<IAgent>();
    customer = input<ICustomerDetails>();
    height = input.required<string>();

    customerId = computed(() => this.customer()?.customerId ?? '');

    agentId = computed(() => this.agent()?.id ?? '');
}
